import { LanguageCode, PointOfSale } from '@flysas-tech/book-value-stream-models';
import { Intersect, Omit, Object, Static } from '@sinclair/typebox';

import { StringEnumSchema } from '../../../utils';
import { RequestHeaders } from '../headers';

export type PartnerAwardHeaders = Static<typeof PartnerAwardHeaders>;
export const PartnerAwardHeaders = Intersect([
  Omit(RequestHeaders, ['accept-language']),
  Object({
    pos: StringEnumSchema(PointOfSale),
    language: StringEnumSchema(LanguageCode),
  }),
]);
